module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-500"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "绑定权限标识",
      "prop": "rule_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 fl w-200",
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.rule_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "rule_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rule_name"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "fl m-l-30",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("查找")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "菜单类型",
      "prop": "menu_type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.menu_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "menu_type", $$v)
      },
      expression: "form.menu_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("普通三级菜单")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("单页菜单")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("外链")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上级菜单",
      "prop": "pid"
    }
  }, [_c('el-select', {
    staticClass: "w-200",
    attrs: {
      "placeholder": "上级菜单"
    },
    model: {
      value: (_vm.form.pid),
      callback: function($$v) {
        _vm.$set(_vm.form, "pid", $$v)
      },
      expression: "form.pid"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "路径"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.$set(_vm.form, "url", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模块",
      "prop": "module"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.module),
      callback: function($$v) {
        _vm.$set(_vm.form, "module", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.module"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属菜单"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.menu),
      callback: function($$v) {
        _vm.$set(_vm.form, "menu", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.menu"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add('form')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    ref: "dialog",
    attrs: {
      "visible": _vm.dialogVisible,
      "custom-class": "w-900 h-480 ovf-auto",
      "title": "节点列表"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "pos-rel h-60"
  }, [_c('el-input', {
    staticClass: "search-btn w-300",
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchMsg()
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.pane_height,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "规则名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "规则标识",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.selectRule(scope.row)
            }
          }
        }, [_vm._v("选择")])], 1)]
      }
    }])
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b31fe4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/system/menu/add.vue
// module id = 1817
// module chunks = 2